import { useColorScheme } from "../custom/colorScheme.ts";

export function useTheme() {
    return { theme: useColorScheme() };
}
